import React from 'react';
import IntlMessages from 'Util/IntlMessages';

// type: primary secondary
// color: green, blue, red, purple, gray, gray-white
// size: x-small small medium large

const BasicTags = ({ type = 'secondary', color = 'green', size = 'medium', children, onClick = () => {}, textId, textMessage, ...props }) => {
  return (
    <div className={`basic-tags-wrapper ${type} ${color} ${size}`} onClick={onClick} {...props}>
      <div className='basic-tags'>
        {children && children}
        {textId ? <IntlMessages id={textId} /> : textMessage}
      </div>
    </div>
  );
};

export default BasicTags;
